import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Authenticated, Unauthenticated } from 'convex/react'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import PermissionErrorBoundary from './components/PermissionErrorBoundary'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ClaimsPage from './pages/ClaimsPage'
import ClaimDetailsPage from './pages/ClaimDetailsPage'
import NewClaimPage from './pages/NewClaimPage'
import DemoModePage from './pages/DemoModePage'

import './App.css'

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">

            <Unauthenticated>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Unauthenticated>

            <Authenticated>
              <ErrorBoundary>
                <PermissionErrorBoundary>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/claims" element={<ClaimsPage />} />
                      <Route path="/claims/new" element={<NewClaimPage />} />
                      <Route path="/claims/:claimId" element={<ClaimDetailsPage />} />
                      <Route path="/demo" element={<DemoModePage />} />
                      <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </Layout>
                </PermissionErrorBoundary>
              </ErrorBoundary>
            </Authenticated>

        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App